import moment from "moment";
import get from "lodash";
const momentTimezone = require('moment-timezone');

export const getDefaultTimezone = () => {
	return 'UTC';
}

export const dateTime = (d, format, timezone) => {
	if (!timezone) {
		timezone = getDefaultTimezone();
	}
	if (!d)
		return "";
	if (!format)
		format = "DD-MM-YYYY";
	return momentTimezone.tz(d * 1000, timezone).format(format);
}

export const number = (d) => {
	const number = d ? d : 0;
	return parseInt(number).toLocaleString();
}

export const todayDateInUnix = () => {
	return Math.floor(moment.unix(moment()).valueOf() / 1000000);
}

export const timeDisplay = (time, format) => {
	if (!time || parseInt(time) === 0) {
		return "-";
	}
	var hr = Math.floor(time / 3600);
	var min = Math.floor(time % 3600 / 60);
	var sec = Math.floor(time % 3600 % 60);

	if (hr <= 0 && min <= 0) {
		return sec + " secs";
	}
	let str = "";
	if (format === "hh:mm") {
		str += hr < 10 ? "0" + hr : hr;
		str += ":";
		str += min < 10 ? "0" + min : min;
	}
	else {
		if (hr > 0)
			str += hr.toString() + ((hr > 1) ? " hrs " : " hr ");
		if (min > 0)
			str += min.toString() + ((min > 1) ? " mins" : " min");
	}
	return str;
}

export const formatDate = (date = 0) => {
	const parseDate = date !== '' && date !== 0 ? moment(date * 1000).toDate() : new Date();
	const month = {
		"short": parseDate.toLocaleString("en-GB", { month: 'short' }),
		"long": parseDate.toLocaleString("en-GB", { month: 'long' })
	};
	return `${parseDate.getDate()} ${month["short"]}, ${parseDate.getFullYear()}`;
}

export const formatDateTime = (d, format = "DD/MM/YYYY HH:mm:ss") => {
	if (d === "" || d === "0001-01-01T00:00:00" || d === "0001-01-01T00:00:00Z" || !d) {
		return "";
	}
	if (d === "now") {
		return moment(new Date()).local().format(format);
	}
	return moment(d).local().format(format);
}


export function time() {
	return Math.floor(new Date().getTime() / 1000);
}

export const getCurrencySymbol = (currency = "GBP") => {
	const currencies = {
		"GBP": "£",
	}
	return get(currencies, currency);
}

export const getCurrentUnixTimeStamp = () => {
	return momentTimezone().unix();
}

export const getTodayDateInUnix = (timezone = getDefaultTimezone()) => {
	return momentTimezone().tz(timezone).startOf("day").unix();
};

export const dateToMomentObject = (date, addPeriod = [], subPeriod = []) => {
	let mDate = date ? moment(date) : moment();
	if (addPeriod.length) {
		mDate.add(addPeriod[0], addPeriod[1]);
	}
	if (subPeriod.length) {
		mDate.subtract(subPeriod[0], subPeriod[1]);
	}
	return mDate;
}

export const dateDiff = (to, from) => {
	const date1 = to ? moment.unix(to) : moment();
	const date2 = from ? moment.unix(from) : moment();

	return date2.diff(date1, 'days') + " days";
}

export const formatTimeAgo = (unixTime) => {
	const time = moment.unix(unixTime);
	const now = moment();

	if (now.diff(time, 'hours') < 24) {
		return time.fromNow(); // e.g., "3 hours ago"
	} else if (now.diff(time, 'days') < 2 && now.day() !== time.day()) {
		return 'yesterday';
	} else {
		return time.format('MMM D, YYYY h:mm A'); // e.g., "Jul 4, 2023 3:15 PM"
	}
};

export const sinceDays = (d) => {
	return moment.utc().diff(moment.unix(d).utc(), 'days')
}

export const addDaysToDate = (days = 0, startDate = moment().utc().startOf("day").unix()) => {
	const d = moment.unix(startDate).utc().startOf("day");
	return d.add(days, "days").unix();
};

export const minYearsAgoUnix = (years = 100) => {
	return moment().subtract(years, 'years').startOf('day').unix();
};

export const maxYearsAheadUnix = (years = 100) => {
	return moment().add(years, 'years').startOf('day').unix();
};